module.exports = __webpack_public_path__ + "static/media/placeholder_3.e961d9bf.jpg";